import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-why-atom-text-container',
  template: `
      <div [formGroup]="_formGroupName">
          <ion-input [attr.type]="_type"
                     [inputmode]="_type"
                     [id]="_id" [ngClass]="_inputClass"
                     [name]="_formControlName"
                     (focus)="onFocus()" (focusout)="outOfFocus()"
                     (ionFocus)="setFocus($event)"
                     (ionBlur)="setFocus($event)"
                     [readonly]="_readOnly"
                     [formControlName]="_formControlName"
                     [formControl]="setControl"
                     [placeholder]="_placeHolderText | translate">
          </ion-input>
      </div>
  `,
  styles: []
})

export class AtomTextComponent implements OnInit {
  @Input() _formGroupName: FormGroup;
  @Input() _formControlName: string;
  @Input() _id: string;
  @Input() _type: string;
  @Input() _placeHolderText: string;
  @Input() _autoComplete: string;
  @Input() _inputClass: string;
  @Input() _readOnly: boolean;
  @Output() inputFocus: EventEmitter<boolean> = new EventEmitter<boolean>();

  focus: boolean;

  constructor() {
  }

  public get setControl(): any {
    // eslint-disable-next-line no-underscore-dangle
    return this._formGroupName.controls[this._id] as FormControl;
    // return this.customForm.controls['starRating'] as FormControl;
  }

  onFocus() {
    this.focus = true;
  }

  setFocus($event) {
    this.inputFocus.emit($event.type === 'ionFocus');
  }

  outOfFocus() {
    this.focus = false;
  }

  ngOnInit(): void {
  }
}
